<!--  -->
<template>
  <div class="switch_dentity">

    <div v-for="(item,index) in data" :key="index" :class="dentityIdx == index ? 'active' : ''"
         @click="dentityChange(index)">
      <span :class="item.icon"></span>
      {{ item.label }}
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: 'switchDentity',
//import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
//这里存放数据
    return {
      userType: "2",
      data: [
        {
          label: '我是老师',
          value: 2,
          icon: "iconfont icon-jiaolian1"
        },
        {
          label: '我是家长',
          value: 3,
          icon: "iconfont icon-boshihouchuzhanshenqing",
        }
      ],
      dentityIdx: 0,
    };
  },
//监听属性 类似于data概念
  computed: {},
//监控data中的数据变化
  watch: {},
//方法集合
  methods: {
    dentityChange(idx) {
      let _this = this;
      _this.dentityIdx = idx;
      this.$emit("dentityEvent", _this.data[_this.dentityIdx].value);
    }
  },
//生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
//生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  lang='less'>
//@import url(); 引入公共css类
.switch_dentity{
display: flex;
div{
font-size: 18px;
padding-right: 58px;
color: #9B9B9B;
cursor: pointer;
span{
font-size: 20px;

}
}
div.active{
color: #FBA5BD;
}
}
</style>